import { inject, ComponentEventBus, prop, needs } from "fw";
import { dispatch } from "fw-state";
import { FormForUser, updateUserFormCreator, UpdateUserAction } from "forms/user";
import { CurrentUserStore } from "state/current-user";
import { PendingEmailAddressDialog } from "views/settings/users/pending-email-address-dialog";
import { EditEmailAddressModal } from "views/settings/users/edit-email-address-modal";

@inject
@needs(PendingEmailAddressDialog, EditEmailAddressModal)
export class MyAccountModal {
    private form: FormForUser = null;
    private saving: boolean = false;
    private showEditEmailAddressModal: boolean = false;

    constructor(
        private currentUser: CurrentUserStore,
        private ceb: ComponentEventBus
    ) {}

    close() {
        this.ceb.dispatch("close");
    }

    async attached() {
        this.form = updateUserFormCreator(this.currentUser.state.user);
    }

    public async save() {
        try {
            this.saving = true;

            const action = new UpdateUserAction(this.form);
            await dispatch(action);

            this.form = updateUserFormCreator(action.updated);
            this.ceb.dispatch("close");
        } catch (err) {
            /*
        let msg = "Could not save user";
        if (err.result && err.result.errors) {
          msg += ": " + err.result.errors.join(", ");
        }
        this.notifier.error(msg);
        */
        } finally {
            this.saving = false;
        }
    }

    public handleDataUpdate(data: FormForUser) {
        this.form = updateUserFormCreator(data);
    }

    public openEditEmailModal() {
        this.showEditEmailAddressModal = true;
    }

    public closeEditEmailModal() {
        this.showEditEmailAddressModal = false;
    }
}
